import globalFilter from '../../../tools/globalFilter'

export default function (state, payload) {
  return {
    ...state,
    azubis: payload.azubis,
  }
}
